export default "__VITE_ASSET__1746193b__"